var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCompanyRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,9.8c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.6,9.8,11.9,9.8z M11.9,4.8c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2 S13,4.8,11.9,4.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 11.7,
    width: 12.1,
    height: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 14.1,
    width: 12.1,
    height: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,22.7c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.3-0.3-0.5v-3.8c-0.6,0-1.4,0-2.8,0c-0.3,0-0.5-0.2-0.5-0.5v-16 c0-0.3,0.2-0.5,0.5-0.5h18c0.3,0,0.5,0.2,0.5,0.5v16c0,0.3-0.2,0.5-0.5,0.5H10.8c-0.8,0.8-4.2,4.2-4.2,4.2 C6.5,22.6,6.4,22.7,6.3,22.7z M6.8,17.8v3.1c2.9-2.9,3.5-3.5,3.8-3.6v0h9.9v-15h-17v15c0.9,0,2.7,0,2.8,0 C6.5,17.3,6.8,17.6,6.8,17.8C6.8,17.8,6.8,17.8,6.8,17.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanyRequest);
export default __webpack_public_path__ + "static/media/icon-company-request.346b8c70817240499702308ad5b64fc7.svg";
export { ForwardRef as ReactComponent };